import React, { Component } from "react";
import { NavBar, Icon } from "antd-mobile";
import $ from "../../ajax/ajax";
import { customerModel } from "../../ajax/index";
import "../Home/home.css";
import "./search.css";
import { createHashHistory } from "history";
const history = createHashHistory();

class SearchHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keyword: "",
      searchFlag: false,
      searchType: "product",
    };
  }
  componentDidMount() {
    let searchKeyword = sessionStorage.getItem("searchKeyword");
    if (searchKeyword) {
      this.setState({
        keyword: searchKeyword,
      });
      this.props.getData(searchKeyword, this.state.searchType);
    }
  }
  // 输入框数据双向绑定
  handKeyWord(e) {
    let _value = e.target.value;
    if (_value) {
      document.getElementById("clearbtn").style.display = "block";
    } else {
      document.getElementById("clearbtn").style.display = "none";
    }
    this.setState({
      keyword: _value,
    });
    this.props.getKeyWord && this.props.getKeyWord(_value);
  }
  // 清除输入框文字
  clearWord() {
    this.setState({
      keyword: "",
    });
    this.props.getKeyWord && this.props.getKeyWord("");
    document.getElementById("clearbtn").style.display = "none";
  }
  back(e) {
    history.goBack();
    e.stopPropagation(); // 阻止事件冒泡
  }
  goHome(e) {
    history.push("/");
    e.stopPropagation(); // 阻止事件冒泡
  }
  changeType(e) {
    e.persist();
    let value = e.target.value;
    this.setState({
      searchType: value,
    });
  }
  // 搜索
  hanldSearch(e) {
    // this.props.setLoading()
    let _this = this;
    let keyword = encodeURIComponent(_this.state.keyword);
    //let keyword = encodeURIComponent(_this.state.keyword);
    if (e.keyCode == 13) {
      sessionStorage.setItem("searchKeyword", keyword);
      this.props.getData(keyword, this.state.searchType);
      this.setState({
        searchFlag: true,
      });

      // $.post({
      //     url: `/tsp/api/v1/anonymity/product/customer/model/` + keyword,
      //     showError: true
      // }).then((res) => {
      //     if (res.status === 200) {

      //         if (res.data.length) {
      //             this.setState({
      //                 searchFlag: true,
      //             })
      //         }

      //         _this.props.searchKeyWord && this.props.searchKeyWord(res);
      //         this.props.getResultsFlag(false)
      //     } else {
      //         this.props.getResultsFlag(true)
      //     }
      // })
    }
  }
  /*提示三次*/
  showTip() {
    history.push(`/scan`);
  }
  render() {
    let goBackClass = "search-header searchHeaderLeftHidden";

    if (this.state.searchFlag) {
      goBackClass = "search-header";
    }
    let qr = require("../../assets/images/home/icon_barcode2.png");
    return (
      <div className="home-style searchHeader search-page">
        <NavBar
          mode="dark"
          leftContent={[
            <div key="0" onClick={this.goHome} className="search goBackClass">
              {" "}
            </div>,
            <div
              to="qrcode"
              key="1"
              onClick={() => {
                this.showTip();
              }}
            >
              {" "}
              <img key="1" width="30" src={qr} alt="图片" />
            </div>,
          ]}
          className="search-header"
          rightContent={[
            <div>
              <select
                name="search_type"
                onChange={(e) => this.changeType(e)}
                className="search_type"
              >
                <option value="product">product</option>
                <option value="display">display</option>
              </select>
              {/* <span
                key="3"
                onClick={this.goHome}
                style={{
                  marginLeft: "10px",
                  height: "44px",
                  lineHeight: "44px",
                }}
              >
                Cancel
              </span> */}
            </div>,
          ]}
        >
          <Icon
            key="0"
            type="search"
            key="0"
            style={{
              width: "30px",
              position: "absolute",
              left: "0px",
              top: "4px",
            }}
          />
          <input
            autoFocus="autofocus"
            className="search-key"
            onKeyUp={this.hanldSearch.bind(this)}
            placeholder="Search Model / Barcode / SN"
            value={this.state.keyword}
            onChange={this.handKeyWord.bind(this)}
            type="search"
          />
          <Icon
            key="0"
            id="clearbtn"
            key="1"
            onClick={this.clearWord.bind(this)}
            type="cross-circle-o"
            size="xxs"
            style={{
              width: "30px",
              position: "absolute",
              right: "10px",
              top: "6px",
            }}
          />
        </NavBar>
      </div>
    );
  }
}

export default SearchHeader;



// WEBPACK FOOTER //
// ./src/pages/search/searchHeader.js